export enum TranscodeInitiatorType {
	DOWNLOAD = 'Download',
	TRANSCRIBE = 'Transcribe'
}

export interface ITranscodeInitiator {
	id?: string;
	type: TranscodeInitiatorType;
}
